export default __webpack_public_path__ + "static/media/loadingGif.10a01a4a.gif";